// extracted by mini-css-extract-plugin
export default {"fieldContainer":"AddCategoryModal_fieldContainer__5XQ09","label":"AddCategoryModal_label__bTSX4"};